import axios from "axios";
import { 
    ADD_TAXATION_EDIT_TAXATION,
    GET_ALL_TAXATION,
    CHANGE_TAXATIONS_STATUS,
    GET_SINGLE_TAXATIONS_DETAILS,
    GET_ALL_ACTIVE_TAXATION
   } from "../config/urlConfig";
import { convertToFormData } from "../utils/commenController";

// <-------------------------TAXATIONS------------------------------------>

// Function for handling ADD & EDIT  taxation  api
export async function handleAddEditTaxationApi(taxationData, token) {
  try {

    let formData = await convertToFormData(taxationData);
    let response = await axios.post(ADD_TAXATION_EDIT_TAXATION, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all taxations
export async function getAllTaxationDetailsApi(token) {
  try {
  
    let response = await axios.get(GET_ALL_TAXATION, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}


// Function for handling change sub taxations status  api
export async function handleChangeTaxationStatusApi(distId, token) {
  try {

    let response = await axios.patch(`${CHANGE_TAXATIONS_STATUS}/${distId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

export async function fetchSingleTaxationsDetailsApi(token , taxationId){
  try{
    try {
  
      let response = await axios.get(`${GET_SINGLE_TAXATIONS_DETAILS}/${taxationId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
  }catch(error){
    console.log("err", error.message);
    
  }
}

// Function for fetch all active taxations
export async function fetchActiveTaxDetailsApi(token) {
  try {
  
    let response = await axios.get(GET_ALL_ACTIVE_TAXATION, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}



